import find from 'lodash/find';

import { default as Languages } from '@ad-scripts/domain/models/languages/answer_languages';
import publicAnswersResource from 'src/actions/answers/publicAnswersResource';
import { EMPTY_ANSWER_ID } from 'src/presentation/components/pages/chat/chatConstants';
import { INTERNAL_ACTION_TYPE } from 'src/presentation/components/pages/chat/chatConstants';
import { STATUS_FAILED } from 'src/presentation/hooks/useResource';
import { DomainError } from 'src/models/DomainError';
import { FIELDS_MAPPER } from 'src/presentation/components/pages/chat/chatConstants';

export default async function validateChatQuickActions(attrs, dispatch, getState) {
  const { selfService, audienceId, lng } = attrs.configuration;

  const answerIds: string[] = selfService.quickActions.reduce(
    (acc, { content }) => (content.type === INTERNAL_ACTION_TYPE ? [...acc, content.value] : acc),
    []
  );

  if (!answerIds.length) {
    return [];
  }

  await dispatch(publicAnswersResource.effects.fetch({ language: lng }));
  const { value, loadingState } = getState().publicAnswers;
  // Only available for network error otherwise loadingState will be succeeded
  if (loadingState === STATUS_FAILED) {
    throw new Error('There was an error while updating');
  }

  return validateAnswers(answerIds, value, audienceId, lng) as DomainError[];
}

function validateAnswers(answerIds, publicAnswers, audienceId, lng) {
  let errors: (string | DomainError)[] = [];

  answerIds.forEach(answerId => {
    if (!find(publicAnswers, pubAnswer => answerId === pubAnswer.id)) {
      errors.push(answerId);
    }
  });

  const errorLength = errors.length;

  if (errorLength) {
    const audienceDetail = audienceId ? ' and your selected audience' : '';

    errors = errors.map(answerId => {
      const params = {
        errorMessage: answerId
          ? `This answer doesn't exist in ${Languages[lng]}${audienceDetail}. Select another answer.`
          : 'Answer should be selected',
        errorAnswerId: answerId || EMPTY_ANSWER_ID,
      };

      return {
        attr: `${FIELDS_MAPPER.SELF_SERVICE_QUICK_ACTIONS.path}[${params.errorAnswerId}].content.value`,
        code: 'invalid',
        detail: params.errorMessage,
      };
    });

    return errors;
  }

  return [];
}
